<template>
  <div>
    <app-header />
    <hr />
    <b-overlay v-if="waitingLoadChart" id="overlay-background" class="overlay-config calendar-seasonal loading" :show="waiting" rounded="sm" >
      <graph-gdi />
      <footer-graph class="footer" />
    </b-overlay>
    <div class="" v-else>
      <h1 class="clockText">{{ $t('selecione-um-periodo') }}</h1>
      <img
        src="@/assets/Monitoramento.png"
        class="iconPermission"
        :alt="$t('selecione-um-periodo')"
        :title="$t('selecione-um-periodo')"
      />
    </div>
  </div>
</template>
 
<script>
import AdherenceIndicatorsHeaderGDI from "./template/AdherenceIndicatorsHeaderGDI.vue";
import AdherenceIndicatorsGraphGDI from "./template/AdherenceIndicatorsGraphGDI.vue";
import AdherenceIndicatorsFooterGDI from "./template/AdherenceIndicatorsFooterGDI.vue";
import MediatorGDI from "./utilites/MediatorGDI";
import axios from "axios";
import { urlMainAPI } from "@/global";

export default {
  components: {
    "app-header": AdherenceIndicatorsHeaderGDI,
    "graph-gdi": AdherenceIndicatorsGraphGDI,
    "footer-graph": AdherenceIndicatorsFooterGDI,
  },

  data() {
    return {
      screenIndicators: "",
      waiting: true,
      waitingLoadChart: false
    };
  },

  methods: {
    async getAllAdherenceIndicatorsByUnits(parameterSearch) {
      this.waitingLoadChart = true
      const url = `${urlMainAPI}/getadherenceandocurrenceproductunit/${parameterSearch.area}/${parameterSearch.shift}/${parameterSearch.dateInitial}/${parameterSearch.dateFinal}`;
      await axios
        .get(url)
        .then(async (res) => {
          this.res = res.status;
          if (this.res == 200) {
            await MediatorGDI.notify(res.data, "loading-infos");
          }
        })
        .catch((e) => {
          console.log(e);
        });
        this.waiting = false;
    },

    showScrenPGDI(unitId) {
      this.$router.push({
        name: "adherenceindicators",
        params: { unitId: unitId },
      });
    },
  },

  async mounted() {
    await MediatorGDI.notify(this, "init");
  },
};
</script>

<style scoped>
hr {
  margin: 8px;
}

.footer {
  width: 99%;
  display: flex;
  position: absolute;
  bottom: 0;
  justify-content: center;
}

.loading {
  display: block;
  min-height: 65.5vh;
  position: absolute;
  top: Calc(50% - 128px);
}
.iconPermission {
  position: absolute;
  width: 300px;
  top: Calc(50% - 158px);
  left: Calc(50% - 158px);
  opacity: 0.1;
}
.clockText {
  position: absolute;
  top: 50%;
  text-align: center;
  width: 99%;
  font-size: 1.5rem;
}

@media (min-height: 928px) {
  .loading {
    height: 69vh;
  }
}
</style>